(function () {
   const input = document.getElementById('siteSearchInput');

   if (!input) return;

   document.addEventListener('keydown', function (e) {
      const isKCombo = (e.metaKey || e.ctrlKey) && e.key === 'k';

      if (!isKCombo) return;

      // Only act when the input is visible — the top bar is hidden below lg breakpoint
      if (input.offsetParent === null) return;

      e.preventDefault();

      input.focus();
      input.select();
   });
})();
